<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="ni ni-tv-2"
        main="Relatórios"
        sub="Aquisição/Retenção de Clientes"
      />

      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-4">
            <label class="form-control-label">Cliente</label>
            <multiselect
              v-model="filter.client"
              :options="clients"
              :loading="isLoadingClients"
              placeholder="Selecione o Cliente"
              track-by="id"
              label="razao_social"
              :internal-search="false"
              @search-change="debouncedSetClients"
            />
          </div>
          <div class="col-12 col-sm-2">
            <label class="form-control-label">Data Início</label>
            <el-date-picker
              v-model="startDate"
              prefix-icon="fa fa-calendar"
              value-format="yyyy-MM-dd"
              format="d 'de' MMMM 'de' yyyy"
              :picker-options="{disabledDate: this.startDateDisabledDates}"
            />
            <div v-if="!startDate && endDate" class="invalid-feedback" style="display: block;">
              Necessário prencher data início
            </div>
          </div>
          <div class="col-12 col-sm-2">
            <label class="form-control-label">Data Fim</label>
            <el-date-picker
              v-model="endDate"
              prefix-icon="fa fa-calendar"
              value-format="yyyy-MM-dd"
              format="d 'de' MMMM 'de' yyyy"
              :picker-options="{disabledDate: this.endDateDisabledDates}"
            />
            <div v-if="startDate && !endDate" class="invalid-feedback" style="display: block;">
              Necessário prencher data fim
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <label class="form-control-label">Tipo do Cliente</label>
            <multiselect
              v-model="selectedClientType"
              :required="true"
              :disabled="isLoadingSummarizedData"
              :options="summarizedClientTypes"
              :loading="isLoadingSummarizedData"
              placeholder="Selecione o Tipo"
              track-by="value"
              label="label"
            />
            <div
              v-if="!selectedClientType"
              class="invalid-feedback"
              style="display: block;"
            >
              Campo obrigatório
            </div>
          </div>
        </div>
        <div slot="footer" class="row justify-content-end mr-1">
            <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
            <base-button :disabled="disabledReportButton" type="primary" @click="getSpreadData()"
              >Gerar Relatório</base-button
            >
        </div>
      </card>
    </div>
    <card ref="report" v-if="selectedClientType">
      <div v-if="false" class="row" style="padding: 20px;"> 
        <div class="col-12 col-sm-4" v-for="clientType in clientTypes" :key="clientType.value">
            <base-button class="mb-2" :type="buttonTypes[clientType.value]" style="width: 100%;"  @click="selectClientType(clientType)">
              <span class="btn-inner--text" style="padding-top: 20px"> 
                <strong>{{ clientType.label }}</strong>
                <p><strong>{{ summarizedData[clientType.value] }}</strong></p>
              </span>
            </base-button>
        </div>
      </div>

      <el-table
        v-loading="isLoading"
        min-width="100%"
        :data="reportData.data"
        class="table-responsive table-striped mb-4"
        header-row-class-name="thead-light"
      >
        <el-table-column
          label="Nome do Cliente"
          prop="name"
          sortable
          min-width="200px"
        />
        <el-table-column
          :label="'Data Primeira Compra'"
          sortable
          v-slot="{row}"
          min-width="200px"
        >
          {{ 
            row.first_purchase_date 
            && new Date(row.first_purchase_date).toLocaleDateString('pt-BR') 
            || 'Sem Dados nesse período' 
          }}
        </el-table-column>
        <el-table-column
          :label="'Data Última Compra'"
          prop="last_purchase_date"
          sortable
          v-slot="{row}"
          min-width="200px"
        >
          {{ 
            row.last_purchase_date 
            && new Date(row.last_purchase_date).toLocaleDateString('pt-BR') 
            || 'Sem Dados nesse período' 
          }}
        </el-table-column>
        <el-table-column
          :label="'Vendedor Última Compra'"
          prop="last_purchase_salesman"
          sortable
          v-slot="{row}"
          min-width="200px"
        >
          {{ row.last_purchase_salesman || 'Sem Dados' }}
        </el-table-column>
        <el-table-column
          :label="'Valor Última Compra'"
          prop="last_purchase_value"
          sortable
          v-slot="{row}"
          min-width="200px"
        >
          {{ 
            row.last_purchase_value 
            && parseFloat(row.last_purchase_value).toLocaleString('pt-BR', {style: 'currency', currency: 'brl', minimumFractionDigits: 2, maximumFractionDigits: 2}) 
            || 'Sem Dados' 
          }}
        </el-table-column>
      </el-table>
      <base-pagination
        v-if="reportData.data"
        v-on:input="getSpreadData"
        v-model="reportData['current']"
        :total="reportData['count']"
        :perPage="reportData['per_page']"
      />
    </card>
  </div>
</template>
<script>

import { Table, TableColumn, DatePicker } from "element-ui";
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


export default {
  components: {
    Multiselect,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
    PageTitle,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      isLoading: false,
      isLoadingSummarizedData: false,
      reportData: {},
      summarizedData: [],
      selectedClientType: null,
      clientTypes: [
        { label: 'Novos', value: 'new' },
        { label: 'Fidelizados', value: 'loyal' },
        { label: 'Perdidos', value: 'lost' },
        { label: 'Recuperados', value: 'recovered' }
      ],
      buttonTypes: {
        withheld: 'primary', 
        recent: 'info', 
        lost: 'danger' 
      },
      filter: {},
      isLoadingClients: false,
      clientsTimeout: null,
      clients: [],
      startDate: null,
      endDate: null,
    }
  },
  mounted() {
    this.getClients()
    this.getSummarizedData()
  },
  computed: {
    summarizedClientTypes: function() {
         this.clientTypes.map(el => {
        return {
          ...el,
          label: el.label + '    -    ' + this.summarizedData[el.value],
          count: this.summarizedData[el.value]
        }
      })
    },
    disabledReportButton: function() {
      !this.selectedClientType || this.isLoadingSummarizedData
    },
  },
  watch: {
    startDate: function (value) {
      if (!this.endDate) return;
      this.getSummarizedData()
    },
    endDate: function (value) {
      if (!this.startDate) return;
      this.getSummarizedData()
    }
  },
  methods: {
    async getSummarizedData() {
      this.isLoadingSummarizedData = true
      let queryParams = {}
      queryParams['start_date'] = this.startDate
      queryParams['end_date']   = this.endDate
      this.summarizedData = await this.getReportData({summarized_data: true, q: queryParams})
      this.isLoadingSummarizedData = false
    },
    async getSpreadData(page = 1) {
      let queryParams           = { client_type: this.selectedClientType.value }
      this.filter['start_date'] = this.startDate
      this.filter['end_date']   = this.endDate
      this.filter['client_id']  = this.filter.client && this.filter.client.id || null
      const { client, ...filter} = this.filter 
      queryParams               = { ...queryParams, q: filter, page: page }
      this.isLoading            = true
      this.reportData           = await this.getReportData(queryParams)
      this.isLoading            = false
    },
    debouncedSetClients(query){
      if (!query) return;
      if (this.clientsTimeout) clearTimeout(this.clientsTimeout);

      this.clientsTimeout = setTimeout(() => this.getClients(query), 500)
    },
    clearFilters() {
      this.filter.client = [],
      this.selectedClientType = null,
      this.startDate = null,
      this.endDate = null
    },
    async getClients(query = null){
      this.isLoadingClients  = true

      let q = {}
      if (query) q['fulltext'] = query;

      try {
        const response        = await this.$http.secured.get("/api/v1/clients", { params: { q } })
        this.clients = response.data.clients
      } catch(error) {
        // this.$toasted.global.defaultError()
      }

      this.isLoadingClients = false
    },
    async getReportData(serviceParams = {}) {
      try {
        const response  = await this.$http.secured.get("/api/v1/report/client_retention_acquisition", {
          params: { service_params: serviceParams }
        })

        return response.data
      } catch (error) {
        return []
      }
    },
    endDateDisabledDates(time) {
      if (time > new Date()) return true;
      
      if (this.startDate) {
        let startDateDateObject = this.dateObject(this.startDate)

        return time < startDateDateObject || startDateDateObject.getFullYear() !== time.getFullYear();
      }

      return false;
    },
    startDateDisabledDates(time) {
      if (time > new Date()) return true;

      if (this.endDate) {
        let endDateDateObject = this.dateObject(this.endDate)

        return time > endDateDateObject || endDateDateObject.getFullYear() !== time.getFullYear();
      }

      return false;
    },
    dateObject(dateString) {
      var dateParts = dateString.split('-');

      // Extracting year, month, and day from the array
      var year = parseInt(dateParts[0]);
      var month = parseInt(dateParts[1]) - 1; // Months are zero-indexed, so subtract 1
      var day = parseInt(dateParts[2]);

      // Creating a Date object
      return new Date(year, month, day);
    }
  },
};
</script>